<template src="./NewSystem.html" />
<script>
import mixins from "@/Mixins.js"

export default {
  mixins: [mixins],
  name: "new-system",
  props: {
    systemId: {
      required: false,
    }
  },
  data() {
    return {
      system: {},
      invalidFields: {
        name: false,
        initials:false,
        source: false,
      }
    }
  },
  created() {
    this.getSystem()
  },
  watch: {
    'system.name': function(newVal) {
      this.invalidFields.name = this.testNullUndefinedEmpty(newVal) && this.invalidFields.name
    },
    'system.initials': function(newVal) {
      this.invalidFields.initials = this.testNullUndefinedEmpty(newVal) && this.invalidFields.initials
    },
    'system.source': function(newVal) {
      this.invalidFields.source = this.testNullUndefinedEmpty(newVal) && this.invalidFields.source
    }
  },
  methods: {
    createSystem() {
      const params = this.system
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .post(this.$store.state.filooServer + "access/systems", params, {
          headers: { Authorization: this.$session.get("bearer") }
        })
        .then( response => {
          if (response.status === 201) {
            this.$swal({
            title: "Sucesso!",
            text: "Sistema cadastrado",
            icon: "success"
            })
            this.$emit('save')
          }
        })
        .catch( () => {
          this.$swal({
          title: "Ocorreu um erro",
          text: "Sistema não cadastrado, contate o administrador",
          icon: "error"
          })
        }).finally( () => {
          this.$vs.loading.close(this.$refs.content)
          this.$emit('cancelar')
        })    
    },
    updateSystem() {
      const params = this.system
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .put(
          this.$store.state.filooServer + `access/systems/${params.id}`,
          params,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => {
          if (response.status === 200) {
            this.$swal({
              title: "Sucesso!",
              text: "Sistema atualizado",
              icon: "success"
            })
            this.$emit('save')
          }
        })
        .catch( () => {
          this.$swal({
            title: "Ocorreu um erro",
            text: "Sistema não atualizado, tente novamente ou contate um administrador.",
            icon: "error"
          })
        }).finally( () => {
          this.$vs.loading.close(this.$refs.content)
          this.$emit('cancelar')
        })
    },
    save() {
      this.invalidFields.name = this.testNullUndefinedEmpty(this.system.name)
      this.invalidFields.initials = this.testNullUndefinedEmpty(this.system.initials)
      this.invalidFields.source = this.testNullUndefinedEmpty(this.system.source)
      if(!this.invalidFields.name && !this.invalidFields.initials && !this.invalidFields.source) {
        this.testNullUndefinedEmpty(this.system.id)? this.createSystem() : this.updateSystem()
      }
    },
    getSystem() {
      if (!this.testNullUndefinedEmpty(this.systemId)) {
        this.$vs.loading({
          container: this.$refs.content,
          scale: 0.5
        })
        this.axios
          .get(this.$store.state.filooServer + `access/systems/${this.systemId}`, {
            headers: { Authorization: this.$session.get("bearer") }
          })
          .then( response => {
            if (response.status === 200) {
              this.$vs.loading.close(this.$refs.content)
              this.system = response.data
            }
          })
      }
    },
    back() {
      this.$router.push("/systems-list")
    },
  },
}
</script>

<style lang="scss" src="./NewSystem.scss"/>